import generateRandomKey from 'draft-js/lib/generateRandomKey';

const isClientContext = typeof window !== 'undefined';
let uuid = 0;

function genKey() {
	return isClientContext ? generateRandomKey() : String(++uuid);
}

Object.keys(require.cache).forEach(key => {
	const mod = require.cache[key];
	if (mod.exports === generateRandomKey) {
		mod.exports = genKey;
	}
});



// WEBPACK FOOTER //
// ./lib/hack-genkey.js